import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'
export const escolaridadeService = {
    
    getComFiltros: (descricao:string = "", estudando:boolean | null) => {        
        return api.get(`${OperacoesWebAPI.Escolaridade}/getcomfiltros`, {params:{ descricao,estudando}})
            .then((res) => res)
            .catch(err => err)
    },
    post:(escolaridade:any) =>{

        return api.post(`${OperacoesWebAPI.Escolaridade}`,escolaridade)
    },
    put:(escolaridade:any) =>{
        return api.put(`${OperacoesWebAPI.Escolaridade}`,escolaridade)
    },

    delete:(escolaridadeID:number) =>{
        return api.delete(`${OperacoesWebAPI.Escolaridade}?id=${escolaridadeID}`)
    }
}